import React from 'react';

const AppointemntIcon = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.25281 3.46803C6.81726 -0.355162 11.5959 -1.12882 14.649 1.70504C17.702 4.5389 17.8643 12.3602 14.649 15.8089C11.4337 19.2576 4.023 18.1512 1.49955 15.8089C-1.0239 13.4667 -0.311651 7.29121 3.25281 3.46803Z"
      fill="#FB9318"
      {...props}
    />
    <g>
      <path
        d="M13.1178 6.13538H13.0149V6.6476C13.0149 6.79315 12.8968 6.91127 12.7512 6.91127C12.6055 6.91127 12.4876 6.79315 12.4876 6.6476V6.13538H11.7145V6.6476C11.7145 6.79315 11.5964 6.91127 11.4508 6.91127C11.3051 6.91127 11.1871 6.79315 11.1871 6.6476V6.13538H10.4141V6.6476C10.4141 6.79315 10.2959 6.91127 10.1504 6.91127C10.0048 6.91127 9.88672 6.79315 9.88672 6.6476V6.13538H9.11328V6.6476C9.11328 6.79315 8.99516 6.91127 8.84961 6.91127C8.70406 6.91127 8.58594 6.79315 8.58594 6.6476V6.13538H7.81285V6.6476C7.81285 6.79315 7.6949 6.91127 7.54918 6.91127C7.40363 6.91127 7.28551 6.79315 7.28551 6.6476V6.13538H6.51242V6.6476C6.51242 6.79315 6.39447 6.91127 6.24875 6.91127C6.1032 6.91127 5.98508 6.79315 5.98508 6.6476V6.13538H5.88207C5.39568 6.13538 5 6.53106 5 7.01762V7.54163H14V7.01762C14 6.53106 13.6041 6.13538 13.1178 6.13538Z"
        fill="white"
      />
      <path
        d="M9.23759 11.3808V12.2293H9.76265V11.3808C9.76265 11.2353 9.8806 11.1172 10.0263 11.1172H10.8746V10.5923H10.0263C9.8806 10.5923 9.76265 10.4741 9.76265 10.3286V9.4801H9.23759V10.3286C9.23759 10.4741 9.11946 10.5923 8.97392 10.5923H8.12524V11.1172H8.97392C9.11946 11.1172 9.23759 11.2353 9.23759 11.3808Z"
        fill="white"
      />
      <path
        d="M5 12.7583C5 13.2448 5.39568 13.6405 5.88207 13.6405H13.1178C13.6041 13.6405 14 13.2448 14 12.7583V8.06897H5V12.7583ZM7.59787 10.3286C7.59787 10.1829 7.716 10.065 7.86154 10.065H8.71022V9.21647C8.71022 9.07075 8.82816 8.9528 8.97389 8.9528H10.0263C10.1718 8.9528 10.29 9.07075 10.29 9.21647V10.065H11.1383C11.2838 10.065 11.402 10.1829 11.402 10.3286V11.3809C11.402 11.5266 11.2838 11.6445 11.1383 11.6445H10.29V12.493C10.29 12.6388 10.1718 12.7567 10.0263 12.7567H8.97389C8.82816 12.7567 8.71022 12.6388 8.71022 12.493V11.6445H7.86154C7.716 11.6445 7.59787 11.5266 7.59787 11.3809V10.3286Z"
        fill="white"
      />
      <path
        d="M9.11328 5.62317C9.11328 5.47762 8.99516 5.3595 8.84961 5.3595C8.70406 5.3595 8.58594 5.47762 8.58594 5.62317V6.1354H9.11328V5.62317Z"
        fill="white"
      />
      <path
        d="M7.81274 5.62317C7.81274 5.47762 7.69479 5.3595 7.54907 5.3595C7.40353 5.3595 7.2854 5.47762 7.2854 5.62317V6.1354H7.81274V5.62317Z"
        fill="white"
      />
      <path
        d="M6.51245 5.62317C6.51245 5.47762 6.3945 5.3595 6.24878 5.3595C6.10323 5.3595 5.98511 5.47762 5.98511 5.62317V6.1354H6.51245V5.62317Z"
        fill="white"
      />
      <path
        d="M13.0149 5.62317C13.0149 5.47762 12.8968 5.3595 12.7512 5.3595C12.6055 5.3595 12.4875 5.47762 12.4875 5.62317V6.1354H13.0149V5.62317Z"
        fill="white"
      />
      <path
        d="M11.7146 5.62317C11.7146 5.47762 11.5965 5.3595 11.4509 5.3595C11.3052 5.3595 11.1873 5.47762 11.1873 5.62317V6.1354H11.7146V5.62317Z"
        fill="white"
      />
      <path
        d="M10.4141 5.62317C10.4141 5.47762 10.2959 5.3595 10.1504 5.3595C10.0048 5.3595 9.88672 5.47762 9.88672 5.62317V6.1354H10.4141V5.62317Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="9" height="9" fill="white" transform="translate(5 5)" />
      </clipPath>
    </defs>
  </svg>
);

export default AppointemntIcon;
